import Vue from "vue";
import App from "./App.vue";
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import VueSession from "vue-session";
import store from "./store/index";
import initAuthService from "./services/authenticationServiceInstance";
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";
import VueToastr from "vue-toastr";
import "./interceptors/cropwiseTokenInterceptor";
import "./interceptors/accessTokenInterciptor";
import "./interceptors/refershTokenInterciptor";
import "./interceptors/errorInterceptor";
import VueRouter from 'vue-router';
import {router}  from './router';

const requireComponent = require.context(
  // The relative path of the components folder
  "./components/apps",
  // Whether or not to look in subfolders
  false,
  // The regular expression used to match base component filenames
  /[A-Z]\w+\.(vue|js)$/
);

requireComponent.keys().forEach(fileName => {
  // Get component config
  const componentConfig = requireComponent(fileName);

  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(
      // Gets the file name regardless of folder depth
      fileName
        .split("/")
        .pop()
        .replace(/\.\w+$/, "")
    )
  );

  // Register component globally
  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    componentConfig.default || componentConfig
  );
});

Vue.use(BootstrapVue);
Vue.use(VueSession);
Vue.use(VueRouter);
Vue.use(VueToastr, {
  /* OverWrite Plugin Options if you need */
});
Vue.config.productionTip = false;

Vue.prototype.$AuthService = initAuthService('azure');

new Vue({
  router,
  render: h => h(App),
  store,
  created: function () {
    // `this` points to the vm instance
    this.$session.start();
  },
  destroyed: function () {
    this.$session.destroy();
  }
}).$mount("#app");

